import React from 'react';
import _ from 'lodash';
import jQuery from 'jquery';

import Modal from 'comp/modal';
import Banner from 'comp/alerts';
import TwoFactorScreen from './TwoFactor';
import UsernamePasswordScreen from './UsernamePassword';
import Portal from 'react-portal';
import loginStateController from 'ub/ui/login/state-controller';
import ubBanzai from 'ub/control/banzai-features';

const LOGIN_ENDPOINT = ubBanzai.getFeatureValue('builderLoginEndpoint');
const WEBAPP_GOOGLE_CALLBACK = ubBanzai.getFeatureValue('builderWebappGoogleOauth2Callback');
const GOOGLE_SSO = ubBanzai.features.isGoogleSsoEnabled();

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpened: false,
      bannerText: 'Please sign in to continue using the builder',
      bannerType: 'warn',
      twoFactorActivated: false,
      rememberMe: false,
    };
    this.submitLogin = this.submitLogin.bind(this);
    this.submitActivation = this.submitActivation.bind(this);
    this.getRememberMe = this.getRememberMe.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setRememberMe = this.setRememberMe.bind(this);
    this.setRememberMeValue = this.setRememberMeValue.bind(this);
    this.setActivation = this.setActivation.bind(this);
    this.loginSuccess = this.loginSuccess.bind(this);
    this.loginFail = this.loginFail.bind(this);
    this.getErrorMessage = this.getErrorMessage.bind(this);
    this.getTwoFactorScreen = this.getTwoFactorScreen.bind(this);
    this.getLoginScreen = this.getLoginScreen.bind(this);
    this.toggleOnLabelClick = this.toggleOnLabelClick.bind(this);
    this.submitLoginWithGoogle = this.submitLoginWithGoogle.bind(this);

    this.stateSubscription = loginStateController
      .loginModalSubject
      .filter((ev) => {
        return ev.type === 'unauthorized';
      })
      .subscribe(() => {
        this.setState({isOpened: true});
      });
  }

  componentWillUnmount() {
    this.stateSubscription.dispose();
  }

  getRememberMe() {
    return this.state.rememberMe ? "1" : "0";
  }

  getErrorMessage(responseJSON) {
    // Response message passed back for wrong credentials
    if (responseJSON && responseJSON.message) {
      return responseJSON.message;
    } else if (responseJSON.prompt_for_otp) {
      // Fallback 2FA message
      return 'This code does not match the one provided.';
    } else {
      // Fallback username and password message
      return `Couldn't log you in as ${this.email.textInput.value}`;
    }
  }

  loginSuccess(response) {
    // 2FA
    if (response.prompt_for_otp) {
      this.setState({
        isLoading: false,
        bannerText: 'Please authenticate to log in',
        bannerType: 'warn',
        twoFactorActivated: true,
      });
    } else {
      this.setState({
        isLoading: false,
        isOpened: false,
        twoFactorActivated: false,
        bannerText: 'Please sign in to continue using the builder',
        bannerType: 'warn',
        rememberMe: false,
      });
      jQuery('meta[name=csrf-token]').attr('content', response.authenticity_token);
    }
  }

  setRememberMeValue(ev) {
    this.setState({
      rememberMe: ev.target.checked
    });
  }

  toggleOnLabelClick() {
    this.rememberMe.checked = !this.rememberMe.checked;
    this.setState({
      rememberMe: this.rememberMe.checked
    });
  }

  loginFail(response) {
    const errorMessage = this.getErrorMessage(response.responseJSON);
    this.setState({
      isLoading: false,
      bannerText: errorMessage,
      bannerType: 'error',
    });
  }

  submitRequest(data, success, failure, url = LOGIN_ENDPOINT) {
    jQuery.ajax({
      type: "POST",
      url,
      data,
      contentType: 'application/x-www-form-urlencoded',
    })
    .done(success)
    .fail(failure);
  }

  submitActivation() {
    this.setState({isLoading: true}, () => {
      const data = jQuery.param({
        user: {
          "remember_me": this.getRememberMe(),
          "otp_attempt": this.activation.textInput.value,
        }
      });
      this.submitRequest(data, this.loginSuccess, this.loginFail);
    });
  }

  submitLogin() {
    this.setState({
      isLoading: true,
      rememberMe: this.state.rememberMe
    }, () => {
      const data = jQuery.param({
        user: {
          "remember_me": this.getRememberMe(),
          "email": this.email.textInput.value,
          "password": this.password.textInput.value,
        }
      });
      this.submitRequest(data, this.loginSuccess, this.loginFail);
    });
  }

  submitLoginWithGoogle(response) {
    const data = jQuery.param({
      omniauth: {
        provider: 'google_oauth2',
        uid: response.getId(),
        info: { email: response.getBasicProfile().getEmail() },
        credentials: { token: response.getAuthResponse().access_token },
        user_flow: 'builder_sign_in'
      }
    });

    this.submitRequest(data, this.loginSuccess, this.loginFail, WEBAPP_GOOGLE_CALLBACK);
  }

  setEmail(input) {
    this.email = input;
  }

  setPassword(input) {
    this.password = input;
  }

  setRememberMe(input) {
    this.rememberMe = input;
  }

  setActivation(input) {
    this.activation = input;
  }

  getTwoFactorScreen() {
    return (
      <TwoFactorScreen
        setActivation={this.setActivation}
        submitActivation={this.submitActivation}
        isLoading={this.state.isLoading}
      />
    );
  }

  getLoginScreen() {
    return (
      <UsernamePasswordScreen
        googleSSOEnabled={GOOGLE_SSO}
        setRememberMe={this.setRememberMe}
        setRememberMeValue={this.setRememberMeValue}
        setEmail={this.setEmail}
        setPassword={this.setPassword}
        submitLogin={this.submitLogin}
        submitLoginWithGoogle={this.submitLoginWithGoogle}
        toggleRememberMe={this.toggleOnLabelClick}
        isLoading={this.state.isLoading}
      />
    );
  }

  render() {
    return (
      <Portal isOpened={this.state.isOpened} closeOnOutsideClick>
        <Modal
          closePortal={_.noop}
          headerClose={false}
          style={{width: "420px"}}
          title="You've been Logged Out"
        >
          <Banner type={this.state.bannerType}>
            {this.state.bannerText}
          </Banner>

          {
            this.state.twoFactorActivated
              ? this.getTwoFactorScreen()
              : this.getLoginScreen()
          }

        </Modal>
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/login/components/Login.jsx